module.exports = __webpack_public_path__ + "img/05.50518705.jpg";